import { Box, Grid2 as Grid, InputAdornment } from "@mui/material";
import { SelectBox, TextField } from "../../../common";
import {
  TRUCK_CAPACITY_UNIT,
  TRUCK_STATUS_DROPDOWN,
  TRUCK_UNASSIGNED_DRIVER,
} from "../../../../constants";
import { TruckStatus } from "../../../../enums";
import {
  DropdownItem,
  ModalForm,
  Truck,
  TruckFormData,
} from "../../../../types";
import { truckFormSchema } from "../../../../validations";
import { useValidateForm } from "../../../../hooks";

type TruckFormProps = ModalForm<
  Truck,
  TruckFormData,
  { drivers: DropdownItem[] }
>;

export const TruckForm = ({
  id,
  defaultValues,
  handleEdit,
  drivers,
}: TruckFormProps) => {
  const { register, handleSubmit, errors } =
    useValidateForm<TruckFormData>(truckFormSchema);
  const driverDropdown: DropdownItem[] = [
    { key: "Unassigned", value: TRUCK_UNASSIGNED_DRIVER },
    ...drivers,
  ];

  return (
    <Box
      onSubmit={handleSubmit(handleEdit)}
      component={"form"}
      id={id}
      noValidate
      sx={{ py: 2 }}
    >
      <Grid container columnSpacing={2} rowSpacing={3}>
        <Grid size={12}>
          <TextField
            label="Truck Name"
            name="name"
            register={register}
            error={errors["name"]}
            defaultValue={defaultValues?.name}
            placeholder="e.g. Sprayer Pro 2500"
            maxLength={100}
            required
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            label="License Plate"
            name="licensePlate"
            register={register}
            error={errors["licensePlate"]}
            defaultValue={defaultValues?.licensePlate ?? ""}
            placeholder="SPZ-000"
            maxLength={20}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            type="number"
            label="Tank Capacity"
            name="capacity"
            register={register}
            valueAsNumber
            allowScientificNotation={false}
            error={errors["capacity"]}
            defaultValue={defaultValues?.capacity}
            placeholder="e.g. 500"
            required
            slotProps={{
              input: {
                endAdornment: (
                  <InputAdornment position="end">
                    {TRUCK_CAPACITY_UNIT}
                  </InputAdornment>
                ),
              },
            }}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <SelectBox
            label="Status"
            name="status"
            register={register}
            error={errors["status"]}
            dropdown={TRUCK_STATUS_DROPDOWN}
            defaultValue={defaultValues?.status ?? TruckStatus.Active}
            required
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <SelectBox
            label="Assigned Driver"
            name="driverId"
            register={register}
            error={errors["driverId"]}
            dropdown={driverDropdown}
            defaultValue={defaultValues?.driverId ?? TRUCK_UNASSIGNED_DRIVER}
            displayEmpty
          />
        </Grid>
      </Grid>
    </Box>
  );
};
